import { render, staticRenderFns } from "./shardingSource.vue?vue&type=template&id=5bb8583d&scoped=true&"
import script from "./shardingSource.vue?vue&type=script&lang=js&"
export * from "./shardingSource.vue?vue&type=script&lang=js&"
import style0 from "./shardingSource.vue?vue&type=style&index=0&id=5bb8583d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8583d",
  null
  
)

export default component.exports